/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Icon } from "../icon";
import "../pageWarning/pageWarning.scss";

const PageWarning = () => {
  return (
    <div className="Container warning-pages">
      <Icon.FolderWarningFill />
      <h4>Cảnh báo</h4>
      <h5>Truy cập không hợp lệ</h5>
      <p>
        Bạn không có quyền truy cập vào chức năng này. Vui lòng liên hệ <a>ADMIN</a> để được hỗ trợ
      </p>
      {/* <button className="btn btn-primary button__warning" onClick={() => history.push('./')}>Quay lại</button> */}
    </div>
  );
};

export default PageWarning;
